// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueIconfont from 'vue-iconfont'
import echarts from 'echarts'
import axios from 'axios'
import Vuerify from 'vuerify'
import './registerServiceWorker'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/element.css'
import './assets/style/common.scss'
import './assets/fonts/iconfont'
import { FilePreviewProvider } from '@/utils/FilePreviewProvider'

const Loading = ElementUI.Loading
const Notification = ElementUI.Notification

Vue.config.productionTip = true
Vue.prototype.$echarts = echarts
Vue.prototype.$http = axios

Vue.use(Vuerify)
let loading

function startLoading () {
    loading = Loading.service({
        lock: true,
        text: '加载中,请稍候',
        background: 'rgba(0, 0, 0, 0.8)'
    })
}

function endLoading () {
    loading.close()
}

let needLoadingRequestCount = 0

export function showFullScreenLoading () {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading () {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}

axios.defaults.baseURL = process.env.VUE_APP_BASE
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.interceptors.request.use(config => {
    showFullScreenLoading()
    if (window.localStorage.getItem('token')) {
        config.headers.token = window.localStorage.getItem('token')
    }
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    if (response.config.url === '/api/checkLoginStatus') {
        tryHideFullScreenLoading()
        return response.data
    } else if (response.data.code === 301) {
        localStorage.removeItem('token')
        localStorage.removeItem('USERINFO')
        tryHideFullScreenLoading()
        router.replace('/maintenance')
    } else if (response.data.code === 1004 || response.data.code === 1005) {
        localStorage.removeItem('token')
        localStorage.removeItem('USERINFO')
        Notification({
            title: '通知消息',
            type: 'error',
            message: response.data.message
        })
        tryHideFullScreenLoading()
        router.replace('/login')
    } else if (response.data.code === 1002) {
        localStorage.removeItem('token')
        localStorage.removeItem('USERINFO')
        tryHideFullScreenLoading()
        router.replace('/login')
        return response.data
    } else {
        tryHideFullScreenLoading()
        return response.data
    }
}, error => {
    tryHideFullScreenLoading()
    return Promise.reject(error)
})

Vue.use(VueIconfont, [{
    tag: 'v-svg-icon',
    prefix: '',
    type: 'svg'
}])

Vue.use(ElementUI)

Vue.prototype.$Message = ElementUI.Message

const tablePathList = [
    '/index/project',
    '/index/project/prepend',
    '/index/member',
    '/index/pay/record',
    '/index/pay/prepaid',
    '/index/finance/capital',
    '/index/finance/fee',
    '/index/info/services',
    '/index/info/members',
    '/index/finance/cash'
]
let lastTablePath = ''
router.beforeEach((to, from, next) => {
    const { path } = to
    if (tablePathList.includes(path) && path !== lastTablePath) {
        lastTablePath = path
        store.commit('resetListCache')
    }
    next()
})

router.afterEach((to, from) => {
    const rC = document.querySelector('.rightContainer')
    if (rC) {
        rC.scrollTop = 0
    }
})

Vue.prototype.$filePreview = FilePreviewProvider
Vue.prototype.$eventBus = new Vue()
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    created () {
        this.$eventBus.$on('showPhotoViewer', (src) => {
            this.$root.$emit('showPhotoViewer', src)
        })
    },
    render: h => h(App)
})
